import cx from 'classnames'
import { FC, HTMLAttributes, ReactNode } from 'react'

import ChevronDown from '../Icons/ChevronDown'
import ChevronUp from '../Icons/ChevronUp'

import * as styles from './CustomAccordion.scss'

interface AccordionItemInterface extends Omit<HTMLAttributes<HTMLDivElement>, 'content'> {
  label: ReactNode
  content: ReactNode
  containerHeaderClassName?: string
  labelClassName?: string
  contentClassName?: string
  disabled?: boolean
}

export interface CustomAccordionItemProps {
  item: AccordionItemInterface
  isOpen: boolean
  handleToggleOpen: () => void
}

const CustomAccordionItem: FC<CustomAccordionItemProps> = ({ item, isOpen, handleToggleOpen }) => {
  const {
    label,
    content,
    containerHeaderClassName,
    contentClassName,
    labelClassName,
    className,
    disabled,
    ...containerItemProps
  } = item
  return (
    <div
      data-testid="custom-accordion-item"
      className={cx(styles.CustomAccordionItem, className)}
      data-open={isOpen}
      {...containerItemProps}
    >
      <div
        data-testid="custom-accordion-item-header"
        className={cx(styles.Header, containerHeaderClassName)}
        onClick={handleToggleOpen}
      >
        <div data-testid="custom-accordion-item-label" className={cx(styles.HeaderLabel)}>
          {label}
        </div>
        {!disabled && (
          <span className={styles.HeaderIcon}>{isOpen ? <ChevronUp /> : <ChevronDown />}</span>
        )}
      </div>
      {isOpen && (
        <div
          data-testid="custom-accordion-item-content"
          className={cx(styles.Content, contentClassName)}
        >
          {content}
        </div>
      )}
    </div>
  )
}

export default CustomAccordionItem
